// import React from 'react';
// import heroImage from '../../../main_assets/hero1.png';

// const Brand = () => {
//   return (
//     <div className="flex flex-row bg-[#f04f4f] items-center section__padding-pad">
//       {/* Image Section */}
//       <div className="flex-1 pr-0">
//         <div 
//           className="relative aspect-video border-t-[8px] border-t-[#E9E9E1]"
//         >
//           <img
//             src={heroImage}
//             alt="Ulevus Design"
//             className="w-full h-full object-cover"
//           />
//           <div className="absolute inset-0 flex items-center justify-center">
//             <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center cursor-pointer">
//               <div className="w-0 h-0 border-l-[20px] border-l-black border-y-[12px] border-y-transparent ml-2"></div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Text Section */}
//       <div className="flex-1 pl-8">
//         <h1 className="text-7xl font-bold mb-4" style={{fontFamily: "Poppins-SemiBold", color: "#E9E9E1", lineHeight: '1.04'}}>
//           Design in it<br />
//           Full Form
//         </h1>
//         <h2 className="text-white text-5xl font-light mb-4" style={{fontFamily: "Poppins-Light", color: "#E9E9E1"}}>
//           By John D
//         </h2>
//         <p className="text-white text-lg mb-2 max-w-xl" style={{fontFamily: "Poppins-Light", color: "#E9E9E1"}}>
//           Designed to the exacting European Passive House Standard, this is architect Cedric Burgers's family home.
//         </p>
//         <button className="text-dark text-2xl font-medium hover:underline" style={{fontFamily: "Poppins-SemiBold"}}>
//           Watch Full Video
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Brand;






import React from 'react';
import heroImage from '../../../main_assets/hero1.png';
import './brand.css'

const Brand = () => {
  return (
    <div className="flex flex-col md:flex-row items-center section__padding-pad" style={{backgroundColor: "#E54141"}}>
      {/* Image Section */}
      <div className="w-full md:w-1/2 md:pr-0">
        <div 
          className="relative aspect-video border-t-[8px] border-t-[#E9E9E1]"
        >
          <img
            src={heroImage}
            alt="Ulevus Design"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center cursor-pointer">
              <div className="w-0 h-0 border-l-[20px] border-l-black border-y-[12px] border-y-transparent ml-2"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Text Section */}
      <div className="w-full md:w-1/2 md:pl-8 px-4 py-6 text-center md:text-left">
        <h1 
          className="text-4xl md:text-6xl lg:text-7xl font-bold mb-4" 
          style={{
            fontFamily: "Poppins-SemiBold", 
            color: "#E9E9E1", 
            lineHeight: '1.04'
          }}
        >
          Design in it<br />
          Full Form
        </h1>
        <h2 
          className="text-3xl md:text-4xl lg:text-5xl font-light mb-4" 
          style={{
            fontFamily: "Poppins-Light", 
            color: "#E9E9E1"
          }}
        >
          By John D
        </h2>
        <p 
          className="text-base md:text-lg mb-4 max-w-xl mx-auto md:mx-0" 
          style={{
            fontFamily: "Poppins-Light", 
            color: "#E9E9E1"
          }}
        >
          Designed to the exacting European Passive House Standard, this is architect Cedric Burgers's family home.
        </p>
        <button 
          className="text-dark text-xl md:text-2xl font-medium hover:underline" 
          style={{fontFamily: "Poppins-SemiBold"}}
        >
          Watch Full Video
        </button>
      </div>
    </div>
  );
};

export default Brand;
